

const videoButtons = [...document.querySelectorAll('.video-toggle')];
videoButtons.forEach((button) => {
  button.addEventListener('click', function () {
    const wrapper = button.closest('.video-wrapper');
    const video = wrapper?.querySelector('video');
    if (!video) return;
    const announcer = document.getElementById('a11y-announcer');
    if (video.paused) {
      video.play();
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', 'Pause video');
      button.setAttribute('data-playing', 'true');
      if (announcer) {
        announcer.textContent = '';
        requestAnimationFrame(() => {
          announcer.textContent = 'Video playing. Press to pause.';
        });
      }

      console.log('announce', 'Video playing. Press to pause.');
    }
    else {
      video.pause();
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Play video');
      button.setAttribute('data-playing', 'false');

      if (announcer) {
        announcer.textContent = '';

        requestAnimationFrame(() => {
          announcer.textContent = 'Video paused. Press to play.';
        });
      }
      console.log('announce', 'Video paused. Press to play.');
    }
  });
});
